import { render, staticRenderFns } from "./WarehouseView.vue?vue&type=template&id=3b217250&scoped=true"
import script from "./WarehouseView.vue?vue&type=script&lang=js"
export * from "./WarehouseView.vue?vue&type=script&lang=js"
import style0 from "./WarehouseView.vue?vue&type=style&index=0&id=3b217250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b217250",
  null
  
)

export default component.exports